import { userInfoAtom } from 'app/atoms';
import { useAtomValue } from 'jotai/index';
import { type Message, Channel } from 'app/types/chat';
import { useUser } from '../user';
import { useQueryKeys } from '../invalidation';

export function useOnMessageReceived() {
  const qk = useQueryKeys();
  return (channelUrl: string) => {
    return qk.afterMessageReceived(channelUrl);
  };
}

export function useGetInterlocutor() {
  const userInfo = useAtomValue(userInfoAtom);
  return (channel: Pick<Channel, 'members' | 'listing'> | undefined): Channel['members'][0] | undefined => {
    if (!userInfo || !channel?.members) return undefined;
    return (
      channel.members.find((m) => m.user_id !== userInfo.id) ??
      (channel.listing?.user
        ? ({
            firstname: channel.listing.user.profile.firstName,
            nickname: channel.listing.user.profile.firstName,
            profile_url: channel.listing.user.profile.picture,
            user_id: channel.listing.user.id,
            isSupport: false,
            trust_points: channel.listing.user.trustPoints,
            insured: channel.listing.user.insured,
            last_seen: channel.listing.user.lastSeenAt,
          } as Channel['members'][0])
        : undefined)
    );
  };
}

export function useGetMyselfInChannel() {
  const userInfo = useAtomValue(userInfoAtom);
  return (channel: Pick<Channel, 'members'> | undefined): Channel['members'][0] | undefined =>
    channel?.members.find((m) => m.user_id === userInfo?.id);
}

export function useIsAuthor() {
  const userInfo = useAtomValue(userInfoAtom);
  const { data: user } = useUser();
  const currentUserId = userInfo?.id ?? user?.id;
  return (message: Message) => !!currentUserId && message.user?.user_id === currentUserId;
}
